import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe, KeyValue } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { SummaryTableComponent } from '../summary-table/summary-table.component';
import {
  InvoiceDetails,
  InvoiceAddressDetails,
  CommercialInvoiceTotalData,
} from '../../models/dynamic.model';
import {
  commercialInvoiceTotalGridColumnConfig,
  mapKeyToLabels,
} from '../../config/common.config';
import { preferredInvoiceDetailsOrder } from 'src/app/features/components/air-waybill/air-waybill.config';

@Component({
  selector: 'app-commercial-invoice',
  templateUrl: './commercial-invoice.component.html',
  styleUrl: './commercial-invoice.component.scss',
  standalone: true,
  imports: [CommonModule, MaterialModule, SummaryTableComponent],
})
export class CommercialInvoiceComponent {
  private _airwayBillInvoiceData: any;
  public freight :any;
  @Input()
  set airwayBillInvoiceData(value: any) {
    if (value) {
      this._airwayBillInvoiceData = value;
      this.initializeInvoice(value);
    }
  }

  get airwayBillInvoiceData(): any {
    return this._airwayBillInvoiceData;
  }

  public invoiceDetails!: InvoiceDetails;
  public shipperConsgineeDetails!: InvoiceAddressDetails[];
  public gridColumnConfig = commercialInvoiceTotalGridColumnConfig;
  public gridData!: CommercialInvoiceTotalData[];

  constructor(private readonly datePipe: DatePipe) {}

  public commercialInvoiceDetailsOrderCompareFn = (
    a: KeyValue<string, any>,
    b: KeyValue<string, any>
  ): number => {
    return (
      preferredInvoiceDetailsOrder.indexOf(a.key) -
      preferredInvoiceDetailsOrder.indexOf(b.key)
    );
  };

  private initializeInvoice(data: any) {
    this.shipperConsgineeDetails = [data.shipper, data.consignee];

    this.invoiceDetails = {
      date: this.datePipe.transform(new Date(), 'MM-dd-yyyy') ?? '',
      currency: 'USD',
      billNumber: data.hawbExt,
      notes: data.notes,
    };
    this.gridData = this.mapCommodityListForInvoice(
      data.shipmentInformation?.commodityList
    );
    this.freight = data.shipmentInformation?.freight ?? '';
  }

  private mapCommodityListForInvoice(
    commodityList: any[] | undefined
  ): CommercialInvoiceTotalData[] {
    if (!commodityList?.length) {
      return [];
    }

    return commodityList.map((item: any) => ({
      ...item,
      description: item?.description ?? '',
      htsCode: item?.htsCode ?? item?.hsCode ?? '',
      hsCode: item?.hsCode ?? item?.htsCode ?? '',
      quantity: item?.quantity ?? '',
      weight: item?.weight ?? '',
      value: item?.value ?? '',
      countryCode:
        item?.countryCode ??
        item?.countryOfManufacturer ??
        item?.countryOfOrigin ??
        '',
      itemNumber: item?.itemNumber ?? '',
    }));
  }

  public renderInvoiceKey(key: string): string {
    return mapKeyToLabels[key];
  }
}
